import { resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.componentName), _mergeProps(_ctx.$props, {
    onEditNode: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('editNode', $event))),
    onDeleteNode: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('deleteNode', $event))),
    onLoadChildren: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('loadChildren', $event))),
    onLoadComments: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('loadComments', $event)))
  }), null, 16))
}